/**
 * 字幕演示视频（含视频背景 + 场景过渡）
 *
 * 用于测试 SmashText fadeIn 预设 + VideoBackground 预设 + 场景间过渡效果
 */

import type { SceneConfig, SubtitleSegment } from "../lib/types";

/** 从 manifest 转换来的字幕段（start/end/seconds） */
const segmentsA: SubtitleSegment[] = [
  { start: 0.0, end: 1.5, text: "第一句：今天天气真不错。" },
  { start: 1.5, end: 3.0, text: "第二句：我们出去走走吧。" },
  { start: 3.0, end: 5.0, text: "第三句：春天的阳光很温暖。" },
];

const segmentsB: SubtitleSegment[] = [
  { start: 0.0, end: 2.0, text: "第四句：路边的花都开了。" },
  { start: 2.0, end: 4.0, text: "第五句：生活真美好。" },
];

const SCENE1_SECONDS = 6.0;
const SCENE2_SECONDS = 5.0;
const SCENE1_FRAMES = Math.ceil(SCENE1_SECONDS * 30); // 180f
const SCENE2_FRAMES = Math.ceil(SCENE2_SECONDS * 30); // 150f

export const subtitleDemoConfig: SceneConfig[] = [
  {
    sceneId: "S01",
    durationInFrames: SCENE1_FRAMES + 15, // 额外半秒收尾
    layers: [
      {
        component: "VideoBackground",
        preset: "officeWoman",
      },
      {
        component: "SmashText",
        preset: "fadeIn",
        props: {
          mainText: "嗨",
          style: { theme: "#FFD700" },
        },
      },
      {
        component: "TimedSubtitle",
        preset: "static",
        props: {
          data: segmentsA,
        },
      },
    ],
  },
  {
    sceneId: "S02",
    durationInFrames: SCENE2_FRAMES + 15,
    transition: {
      type: "fade",
      durationInFrames: 30,
    },
    layers: [
      {
        component: "VideoBackground",
        preset: "natureLandscape",
      },
      {
        component: "TimedSubtitle",
        preset: "static",
        props: {
          data: segmentsB,
        },
      },
    ],
  },
];
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
